var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.153 7.78396C18.8266 7.45938 18.299 7.46083 17.9744 7.78713L7.95669 17.859C6.65701 19.1587 4.54614 19.1587 3.24404 17.8573C1.94291 16.5555 1.94291 14.4446 3.24419 13.1433L13.5585 2.7749C14.3699 1.96351 15.6891 1.96351 16.5029 2.77666C17.3164 3.59019 17.3164 4.90924 16.5027 5.72301L7.95825 14.2674C7.9577 14.2679 7.95723 14.2685 7.95669 14.2691C7.63117 14.5928 7.1051 14.5924 6.78025 14.2675C6.45485 13.9421 6.45485 13.4147 6.78025 13.0893L10.9046 8.96414C11.23 8.63867 11.2299 8.111 10.9045 7.7856C10.579 7.4602 10.0513 7.46024 9.72591 7.78572L5.60163 11.9108C4.6254 12.8871 4.6254 14.4697 5.60171 15.446C6.57798 16.4223 8.16068 16.4223 9.13699 15.446C9.13812 15.4449 9.13902 15.4437 9.14011 15.4425L17.6812 6.90148C19.1458 5.43683 19.1458 3.06248 17.6812 1.59784C16.2163 0.134054 13.8421 0.134054 12.3784 1.59784L2.06409 11.9664C0.113495 13.917 0.113494 17.0829 2.06549 19.0358C4.01878 20.9881 7.18471 20.9881 9.13683 19.036L19.1562 8.9625C19.4807 8.63617 19.4793 8.10854 19.153 7.78396Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.0b05a184.svg";
export { ForwardRef as ReactComponent };